module.exports = __webpack_public_path__ + "static/scale-model-of-sculpture-milwaukee-in-milwaukee-wisconsin-3f307d539f1fe801e337113fb3b07b2f.png";